import { makeStyles } from "@material-ui/styles";


const useStyle = makeStyles({
    insuranceParent: {
        padding: '0 1rem',
        fontSize: '17px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '50%',
        margin: '1rem auto',
        "@media (max-width: 1000px)": {
            width: '100%',
            fontSize: '14px'
        },
        "@media (max-width: 600px)": {
            fontSize: '12px'
        }
    },
    insuranceName: {
        width: '150px',
        "@media (max-width: 600px)": {
            width: '100px',
        }
    },
    insurancePrice: {
        width: '150px',
        textAlign: 'center',
        "@media (max-width: 600px)": {
            width: '100px',
        }
    },
    inputParent: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        width: '60%',
        margin: '5rem auto 0 auto',
        "@media (max-width: 1000px)": {
            width: '100%',
        }
    }
});

export default useStyle;